export const eInputTypes = {
  EIT_BUTTON: 'button',
  EIT_INPUT: 'input',
}
